export default "__VITE_ASSET__222b8034__"